import { render, staticRenderFns } from "./CreateContractorModal.vue?vue&type=template&id=12b6bf0b"
import script from "./CreateContractorModal.vue?vue&type=script&lang=js"
export * from "./CreateContractorModal.vue?vue&type=script&lang=js"
import style0 from "./CreateContractorModal.vue?vue&type=style&index=0&id=12b6bf0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports